import './index.scss';
import { DateTime } from 'luxon';
import React from 'react';
import CommentsCell from './cell/comments_cell';
import CompetitorCell from './cell/competitor_cell';
import DocumentTitleCell from './cell/document_title_cell';
import FormTitleCell from './cell/form_title_cell';
import StatusCell from './cell/status_cell';
export var ColumnName;
(function (ColumnName) {
    ColumnName["Checkbox"] = "checkbox";
    ColumnName["Collapsible"] = "collapsible";
    ColumnName["CreatedOn"] = "createdOn";
    ColumnName["Status"] = "status";
    ColumnName["CreatedBy"] = "createdBy";
    ColumnName["FormTitle"] = "formTitle";
    ColumnName["DocumentTitle"] = "filename";
    ColumnName["Competitor"] = "competitor";
    ColumnName["Comments"] = "comments";
})(ColumnName || (ColumnName = {}));
export const defaultColumnDef = {
    resizable: false,
};
const buildColumnDefs = (hideCommentsCol) => {
    return [
        {
            field: ColumnName.Checkbox,
            headerName: '',
            checkboxSelection: true,
            showDisabledCheckboxes: true,
            suppressSizeToFit: true,
            width: 5,
        },
        {
            field: ColumnName.Collapsible,
            headerName: '',
            width: 10,
            suppressSizeToFit: true,
            cellRenderer: (props) => {
                let baseClass = 'fas ';
                baseClass += props.data.isCollapsed
                    ? 'fa-chevron-right'
                    : 'fa-chevron-down';
                const result = (React.createElement("span", { className: 'chevron-cell' },
                    React.createElement("i", { className: baseClass })));
                return result;
            },
        },
        {
            field: ColumnName.CreatedOn,
            headerName: 'CREATED',
            headerTooltip: 'CREATED',
            cellClass: 'text-color-blue',
            suppressSizeToFit: true,
            width: 100,
            valueGetter: (parm) => DateTime.fromISO(`${parm.data.createdAt}Z`)
                .toLocaleString({ month: 'short', day: '2-digit' }),
        },
        {
            field: ColumnName.Status,
            headerName: 'STATUS',
            headerTooltip: 'STATUS',
            minWidth: 170,
            width: 180,
            maxWidth: 200,
            cellRenderer: (props) => StatusCell(props),
        },
        {
            field: ColumnName.CreatedBy,
            headerName: 'CREATED BY',
            headerTooltip: 'CREATED BY',
            cellRenderer: (props) => (React.createElement("span", { title: props.value }, props.value)),
        },
        {
            field: ColumnName.FormTitle,
            headerName: 'FORM TITLE',
            headerTooltip: 'FORM TITLE',
            autoHeight: true,
            cellClass: (params) => {
                return params.data.isCollapsed
                    ? 'form-title'
                    : '';
            },
            cellRenderer: (props) => FormTitleCell(props),
        },
        {
            field: ColumnName.DocumentTitle,
            headerName: 'DOCUMENT TITLE',
            headerTooltip: 'DOCUMENT TITLE',
            autoHeight: true,
            cellClass: 'text-color-blue',
            cellRenderer: (props) => DocumentTitleCell(props),
        },
        {
            field: ColumnName.Competitor,
            headerName: 'COMPETITOR',
            headerTooltip: 'COMPETITOR',
            cellRenderer: (props) => CompetitorCell(props),
        },
        {
            field: ColumnName.Comments,
            headerName: '',
            suppressSizeToFit: true,
            width: 10,
            hide: hideCommentsCol,
            cellClass: () => 'comments-cell',
            headerTooltip: ColumnName.Comments.toLocaleUpperCase(),
            cellRenderer: (props) => CommentsCell(props),
        },
    ];
};
export default buildColumnDefs;
